/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_Col_SkuInputs */

const vi_online_price_col_sku = /** @type {(inputs: Online_Price_Col_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU`)
};

/**

* @param {Online_Price_Col_SkuInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_col_sku = /** @type {((inputs?: Online_Price_Col_SkuInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Col_SkuInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_col_sku(inputs)
});